import type { FaireProductEntity } from "../../entity_types/product";

export const p_a6yxrkb4x3: FaireProductEntity = {
  token: "p_a6yxrkb4x3",
  type: "product",
  name: "SK2264 Ladies Solitaire Skull Ring Imitation Black Stone Stainless Steel Motorcycle Biker Jewelry Sizes 5-10",
  brandToken: "b_7uqvqdhwrg",
  brandName: "Heavy Metal Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/b9f50c61afa15b288d7bcc73ae2dec85319341aa692a0f576525fe03b14a3fe6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d0cf85f85a9640d87ff6886701210770c82efa9f327f69d03662a1f362793577.jpeg",
    "https://cdn.faire.com/fastly/eeb125ac33b21e265a153343605916b8db57d71599a802f7d5a0f7fa6f122287.png",
  ],
  priceDollars: 9.42,
  description:
    "SK2264 Ladies Solitaire Skull Ring Imitation Black Stone\nStainless Steel Motorcycle Biker Jewelry\nSizes 5-10\n• 🔥 Limited stock available\n• 🇺🇸 Free Shipping in the USA\n• Backed by our No-Hassle Lifetime Warranty",
  tags: [],
  msrpDollars: 28.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:54.220Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
